import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  prospectSelected:any = {};
  constructor() { }

  setProspectSelected(data:any) {
    this.prospectSelected = data;
  }

  getProspectSelected() {
    return this.prospectSelected;
  }
}
